export default __webpack_public_path__ + "static/6_37-0feb5b722be0a38e17e9367deb81095c.png";